


































import { Component, Prop } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import BaseInput from "@/app/core/component/BaseInput.vue";
import { StoreUseData } from "@/@types/store";
import { SceneAndObject } from "@/@types/room";
import VueEvent from "@/app/core/decorator/VueEvent";
import { SceneObject } from "@/@types/gameObject";
import ComponentVue from "@/app/core/window/ComponentVue";
import draggable from "vuedraggable";
import SCheck from "@/app/basic/common/components/SCheck.vue";

@Component({ components: { SCheck, BaseInput, draggable } })
export default class EditSceneObjectComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: Object, required: true })
  private sceneObject!: StoreUseData<SceneObject>;

  @Prop({ type: Object, default: null })
  private sceneAndObject!: StoreUseData<SceneAndObject>;

  @Prop({ type: Boolean, required: true })
  private isSelected!: boolean;

  @Prop({ type: Boolean, required: true })
  private isOrderChanging!: boolean;

  @Prop({ type: Boolean, required: true })
  private dragMode!: boolean;

  @VueEvent
  private onHoverView(isHover: boolean) {
    if (isHover) this.$emit("onMouseHoverAddress", true);
    else {
      if (this.dragMode) this.$emit("onMouseHoverOrder", true);
      else this.$emit("onMouseHoverAddress", false);
    }
  }
}
